import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';
import Text from 'components/base/Text';

export const InviteHeader = styled.h3`
  color: ${lightColorPalette.lbTextSubdued};
  font-size: 1.4rem;
  font-weight: 400;
  margin: 0 0 0.2rem;
  line-height: 22px;
  letter-spacing: 0.3px;
`;

export const InviteAdminEmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 2rem;
  > input {
    line-height: 28px;
  }

  > input:focus-visible {
    ${({ isError }) =>
      isError && `border: 1px solid ${lightColorPalette.lbRedDark}`};
    outline: none;
  }
`;

export const InviteAdminSubmitWrapper = styled.div`
  margin: 1rem 0 2rem;
  position: relative;
`;

export const InviteAdminEmailErrorText = styled(Text)`
  color: ${lightColorPalette.lbRedDark};
  position: relative;
  top: 5px;
`;
